export default {
    'zh_CN': {
        'ipms.attendance-manager.id.label': 'id',
        'ipms.attendance-manager.id.holder': '请输入id',
        
        
        'ipms.attendance-manager.id.required': 'id必填',
        'ipms.attendance-manager.userId.label': '管理员姓名',
        'ipms.attendance-manager.userId.holder': '请选择管理员姓名',
        
        
        'ipms.attendance-manager.userId.required': '用户ID必填',
        'ipms.attendance-manager.attendanceGroup.label': '考勤分组',
        'ipms.attendance-manager.attendanceGroup.holder': '请输入考勤分组',
        
        
        'ipms.attendance-manager.attendanceGroup.dictionary': ()=>[{value:0,label:'路工'},{value:1,label:'派遣'},{value:2,label:'货四股'},{value:3,label:'物业'}],
        'ipms.attendance-manager.attendanceGroup.required': '考勤分组必填',
        'ipms.attendance-manager.remark.label': '备注',
        'ipms.attendance-manager.remark.holder': '请输入备注',
        'ipms.attendance-manager.remark.max': '备注最多500个字符',
        
        'ipms.attendance-manager.remark.required': '备注必填',

        'ipms.attendance-manager.nackname.label': '管理员姓名',
        'ipms.attendance-manager.nackname.holder': '请选择管理员姓名',

        'ipms.attendance-manager.createTime.label': '创建时间',
        'ipms.attendance-manager.createTime.holder': '请输入创建时间',
        'ipms.attendance-manager.createTime.required': '创建时间必填',
        'ipms.attendance-manager.updateTime.label': '更新时间',
        'ipms.attendance-manager.updateTime.holder': '请输入更新时间',
        'ipms.attendance-manager.updateTime.required': '更新时间必填',
        'ipms.attendance-manager.deleted.label': '是否删除',
        'ipms.attendance-manager.deleted.holder': '请输入是否删除',
        'ipms.attendance-manager.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'ipms.attendance-manager.id.label': 'id',
        'ipms.attendance-manager.id.holder': '請輸入id',
        
        
        'ipms.attendance-manager.id.required': 'id必填',
        'ipms.attendance-manager.userId.label': '用户ID',
        'ipms.attendance-manager.userId.holder': '請輸入用户ID',
        
        
        'ipms.attendance-manager.userId.required': '用户ID必填',
        'ipms.attendance-manager.attendanceGroup.label': '考勤分组',
        'ipms.attendance-manager.attendanceGroup.holder': '請輸入考勤分组',
        
        
        'ipms.attendance-manager.attendanceGroup.required': '考勤分组必填',
        'ipms.attendance-manager.remark.label': '备注',
        'ipms.attendance-manager.remark.holder': '請輸入备注',
        'ipms.attendance-manager.nackname.label': '管理员姓名',
        'ipms.attendance-manager.nackname.holder': '請輸入管理员姓名',
        
        
        'ipms.attendance-manager.remark.required': '备注必填',
        'ipms.attendance-manager.createTime.label': '创建时间',
        'ipms.attendance-manager.createTime.holder': '請輸入创建时间',
        
        
        'ipms.attendance-manager.createTime.required': '创建时间必填',
        'ipms.attendance-manager.updateTime.label': '更新时间',
        'ipms.attendance-manager.updateTime.holder': '請輸入更新时间',
        
        
        'ipms.attendance-manager.updateTime.required': '更新时间必填',
        'ipms.attendance-manager.deleted.label': '是否删除',
        'ipms.attendance-manager.deleted.holder': '請輸入是否删除',
        
        
        'ipms.attendance-manager.deleted.required': '是否删除必填'
    },
    'en_US': {
        'ipms.attendance-manager.id.label': 'id',
        'ipms.attendance-manager.id.holder': 'Enter id',
        'ipms.attendance-manager.id.max': 'id max length: id',
        
        
        'ipms.attendance-manager.id.required': 'id required',
        'ipms.attendance-manager.userId.label': 'userId',
        'ipms.attendance-manager.userId.holder': 'Enter userId',
        'ipms.attendance-manager.userId.max': 'userId max length: 用户ID',
        
        
        'ipms.attendance-manager.userId.required': 'userId required',
        'ipms.attendance-manager.attendanceGroup.label': 'attendanceGroup',
        'ipms.attendance-manager.attendanceGroup.holder': 'Enter attendanceGroup',
        'ipms.attendance-manager.attendanceGroup.max': 'attendanceGroup max length: 考勤分组',
        
        
        'ipms.attendance-manager.attendanceGroup.required': 'attendanceGroup required',
        'ipms.attendance-manager.remark.label': 'remark',
        'ipms.attendance-manager.remark.holder': 'Enter remark',
        'ipms.attendance-manager.remark.max': 'remark max length: 备注',
        'ipms.attendance-manager.nackname.label': 'manager nackname',
        'ipms.attendance-manager.nackname.holder': 'Enter manager nackname',
        
        
        'ipms.attendance-manager.remark.required': 'remark required',
        'ipms.attendance-manager.createTime.label': 'createTime',
        'ipms.attendance-manager.createTime.holder': 'Enter createTime',
        'ipms.attendance-manager.createTime.max': 'createTime max length: 创建时间',
        
        
        'ipms.attendance-manager.createTime.required': 'createTime required',
        'ipms.attendance-manager.updateTime.label': 'updateTime',
        'ipms.attendance-manager.updateTime.holder': 'Enter updateTime',
        'ipms.attendance-manager.updateTime.max': 'updateTime max length: 更新时间',
        
        
        'ipms.attendance-manager.updateTime.required': 'updateTime required',
        'ipms.attendance-manager.deleted.label': 'deleted',
        'ipms.attendance-manager.deleted.holder': 'Enter deleted',
        'ipms.attendance-manager.deleted.max': 'deleted max length: 是否删除',
        
        
        'ipms.attendance-manager.deleted.required': 'deleted required'
    }
}
